import { ReactKeycloakProvider } from "@react-keycloak/web";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Spinner from "./components/spinner/Spinner";
import "./index.scss";
import { routes } from "./route/routes";
import ControlledRoute from "./security/controlledRoute";
import keycloak from "./security/keycloak-config";
import { getEffectiveRoutes } from "./security/route";
import store from "./store";

console.log("NEW DEVS ADDED");

const Root: React.FC = () => {
  return (
    <ReactKeycloakProvider authClient={keycloak}>
      <Provider store={store}>
        <Spinner />
        {/* DO NOT MODIFY in production branch - basename must be "/e-learning" for proper routing */}
        <BrowserRouter basename="/mediatheque">
          <App>
            {getEffectiveRoutes(routes).map(({ path, Component, exact, roles }) => (
              <ControlledRoute key={path} exact={exact} path={`${path}`} roles={roles}>
                <Component />
              </ControlledRoute>
            ))}
          </App>
        </BrowserRouter>
      </Provider>
    </ReactKeycloakProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
